// extracted by mini-css-extract-plugin
export default {"SegmentedButtonSet":"SegmentedButtonSet_SegmentedButtonSet__x7T-C","SegmentedButtonSet-buttons":"SegmentedButtonSet_SegmentedButtonSet-buttons__EOU19"};